import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import {PencilIcon} from '@primer/octicons-react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {RenamedTitleEventNode} from './issue-viewer-view-query-types'
import styles from './RenamedTitleEvent.module.css'
import {TimelineRow} from './row/TimelineRow'

// RELAY-CLEANUP(RenamedTitleEvent): widens nullable fields so still-Relay parent data is assignable.
// Remove when the timeline pagination fragments leave Relay.
export type RenamedTitleEventFragment = RelayCompat<
  Pick<RenamedTitleEventNode, 'actor' | 'createdAt' | 'currentTitle' | 'databaseId' | 'previousTitle'>
>

type RenamedTitleEventProps = {
  queryRef: RenamedTitleEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function RenamedTitleEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: RenamedTitleEventProps): React.ReactElement {
  const {actor, createdAt, currentTitle, previousTitle, databaseId} = queryRef

  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={PencilIcon}
    >
      <TimelineRow.Main>
        {LABELS.timeline.renamedTitle}{' '}
        <span className={styles.defaultColor}>
          <del className={styles.strikeThrough}>
            <span className="sr-only">[-]</span>
            {previousTitle}
            <span className="sr-only">[/-]</span>
          </del>
        </span>{' '}
        <span className={styles.defaultColor}>
          <ins className={styles.noUnderline}>
            <span className="sr-only">[+]</span>
            {currentTitle}
            <span className="sr-only">[/+]</span>
          </ins>
        </span>{' '}
      </TimelineRow.Main>
    </TimelineRow>
  )
}
